exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visualMaskCom {\n  position: relative;\n}\n.visualMaskCom.actived > .visualMaskCom-border {\n  border: 4px solid blueviolet;\n}\n.visualMaskCom-mask {\n  position: absolute;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99999;\n}\n.visualMaskCom-border {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99998;\n}\n", ""]);

// exports
